export default {
  "content": "<path d=\"M10 5a2 2 0 114.001.001A2 2 0 0110 5zM10 12a2 2 0 114.001.001A2 2 0 0110 12zM12 17a2 2 0 10.001 4.001A2 2 0 0012 17z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};